// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"494": "4077578422d4","5395": "b9049a98ba70","6863": "454c9f289029","8795": "631c6af3ebb8",}[chunkId] + ".css"
}